
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommRepairGrid extends Serenity.EntityGrid<ECommRepairRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommRepair'; }
        protected getDialogType() { return ECommRepairDialog; }
        protected getIdProperty() { return ECommRepairRow.idProperty; }
        protected getInsertPermission() { return ECommRepairRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommRepairRow.localTextPrefix; }
        protected getService() { return ECommRepairService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
            this.toolbar.findButton('add-button').find('.button-inner').text('New Invoice');
            this.slickGrid.setOptions({ rowHeight: 30 });

            //this.addButtonClick();
        }

        protected addButtonClick() {
            
            let now = new Date();
            var voucher = FormatHelper.GetVoucherNo(48);

            this.editItem(<ECommRepairRow>{
                VoucherNo: voucher,
                Line_No: 0,
                VoucherTypeId: 48,
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                UserId: Q.Authorization.userDefinition.UserId,
                CurrencyId: Q.Authorization.userDefinition.CurrencyId,
                TransDate: now.toDateString()
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}